var map = {
	"./100k/level-2.png": "1a03",
	"./10k/level-2.png": "cf32",
	"./200k/level-2.png": "0eea",
	"./25k/level-2.png": "4331",
	"./300k/level-2.png": "6ba6",
	"./50k/level-2.png": "45c7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "004f";